export default {"src":"/_next/static/media/TJX.612af94d.svg","height":18,"width":18};